import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";
import Switch from "../../components/switch";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, id } = useAddWorkProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <Label label={id ? "Update Blog Details" : "Add Blog Details"} className="text-[18px] text-black" />
      <Formik initialValues={initialValues} enableReinitialize={true} onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <div className="flex items-center space-x-2">
                <Label label="Is Published ?" className="text-black mr-4 mt-3 text-[15px]" />
                <Switch
                  className="pt-1"
                  type="switch"
                  name="is_published"
                  onChange={(val) => setFieldValue("is_published", val)}
                  checked={values.is_published}
                />
              </div>
            </div>

            <div className="flex flex-col">
              <div className="flex flex-col">
                <Label label="Question" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="ques" rootClassName="w-[50%]" />
              </div>

              <div className="flex flex-col">
                <Label label="Answer" className="mb-2 mt-4 text-black text-[15px]" />
                <FormikTextarea name="ans" rootClassName="w-[50%]"  />
              </div>
            </div>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
